import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocPopup } from '../../models/dialog.models';

@Component({
    selector: 'doc-popup',
    templateUrl: 'popup.component.html',
    styleUrls: ['popup.component.scss']
})

export class DocPopupComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DocPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DocPopup
    ) { 
         console.log(data,"data");
    }

    ngOnInit() { }

    close(status) {
        this.dialogRef.close(status);
    }
}